import { createSlice } from "@reduxjs/toolkit";
import { CommonState } from "./types";



export const initialState: CommonState = {
  loading: false,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
  },
});

export const {
  startLoading,
  stopLoading,
} = commonSlice.actions;

export default commonSlice.reducer;
